export default __webpack_public_path__ + "fonts/spectral-v6-latin-500italic.woff";